import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const UserHome = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  
  React.useEffect(() => {
    if (!currentUser) {
      navigate('/login');
    }
  }, [currentUser, navigate]);
  
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">Welcome to GamePreBattle</h1>
      <div className="bg-white dark:bg-gray-800 shadow-md rounded-lg p-6">
        <div className="flex items-center mb-4">
          <div className="flex-shrink-0 h-12 w-12 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center text-blue-600 dark:text-blue-300">
            {currentUser?.email?.charAt(0).toUpperCase() || 'U'}
          </div>
          <div className="ml-4">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
              {currentUser?.email || 'User'}
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400">User Account</p>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
          <div onClick={() => navigate('/matches')} className="p-4 bg-blue-50 dark:bg-blue-900/30 rounded-lg cursor-pointer hover:bg-blue-100 dark:hover:bg-blue-800/30 transition">
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Matches</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">View upcoming and live cricket matches</p>
          </div>
          
          <div onClick={() => navigate('/wallet')} className="p-4 bg-green-50 dark:bg-green-900/30 rounded-lg cursor-pointer hover:bg-green-100 dark:hover:bg-green-800/30 transition">
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Wallet</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">Manage your predictions and balance</p>
          </div>
          
          <div onClick={() => navigate('/earn')} className="p-4 bg-yellow-50 dark:bg-yellow-900/30 rounded-lg cursor-pointer hover:bg-yellow-100 dark:hover:bg-yellow-800/30 transition">
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Earn</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">Discover ways to earn more coins</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserHome; 